import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { GREAT_CHOICE_IMAGES } from '@/pages/Onboarding/options/SettingSelector/SETTING_SELECTOR_OPTIONS';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { GreatChoiceStyles, BackgroundWrapper } from './GreatChoice.styles';
import { getDynamicDescription } from './utils/getDynamicDescription';

export const ScreenGreatChoice: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'GreatChoice',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const settingSelector = form.watch('setting_selector');
  const age = form.watch('age');
  const bodyShape = form.watch('body_shape');
  const gender = form.watch('gender');

  const getBackgroundImage = () => {
    if (!settingSelector) return '';

    const selectedOption = GREAT_CHOICE_IMAGES.find(
      (option) => option.id === settingSelector,
    );

    if (selectedOption) {
      return selectedOption.spriteSrc;
    }

    return '';
  };

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <GreatChoiceStyles>
      <BackgroundWrapper backgroundImage={getBackgroundImage()}>
        <IonContent>
          <div className="content-wrapper">
            <OwnAiTitle className={'title'}>Great choice!</OwnAiTitle>

            <UiTypography
              variant={'body-large'}
              color={'neutral-white'}
              className={'description'}
            >
              {getDynamicDescription(age, bodyShape, gender)}
            </UiTypography>
          </div>
        </IonContent>
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonText="Awesome!"
          buttonSize="large"
        />
      </BackgroundWrapper>
    </GreatChoiceStyles>
  );
};
